var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoleto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.4996,
    cy: 38.4,
    r: 38.4,
    fill: "#0094D1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0498 54.0088V22.3916L26.4248 24.7666L28.7998 22.3916L31.1748 24.7666L33.5498 22.3916L35.9248 24.7666L38.2998 22.3916L40.6748 24.7666L43.0498 22.3916L45.4248 24.7666L47.7998 22.3916L50.1748 24.7666L52.5498 22.3916V54.0088L50.1748 51.6338L47.7998 54.0088L45.4248 51.6338L43.0498 54.0088L40.6748 51.6338L38.2998 54.0088L35.9248 51.6338L33.5498 54.0088L31.1748 51.6338L28.7998 54.0088L26.4248 51.6338L24.0498 54.0088ZM47.7998 33.4502V30.2588H28.7998V33.4502H47.7998ZM47.7998 39.7588V36.6416H28.7998V39.7588H47.7998ZM47.7998 46.1416V42.9502H28.7998V46.1416H47.7998Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoleto);
export default __webpack_public_path__ + "static/media/boleto.dce5f408560a6d0b6f4d28fabf4666f4.svg";
export { ForwardRef as ReactComponent };